import { useEffect } from 'react'
import { useAuth } from '@app/contexts/auth'
import { analytics } from '../index'
import { requestChannel, shareChannel, songChannel } from '../channels'

export const useAnalytics = () => {
  const { authData } = useAuth()

  useEffect(() => {
    if (!analytics) {
      return undefined
    }

    const channels = [requestChannel, shareChannel, songChannel]

    if (authData?.authenticated) {
      analytics.setScreen(window.location.pathname)

      analytics.setUser({
        auth: 'true',
        proRights: {},
      })

      analytics.setGlobalParams({
        userId: authData.user?.id,
        userType: authData.user?.type,
        date: new Date().toISOString(),
      })

      channels.forEach(channel => {
        channel.setParams({})
      })
    } else {
      analytics.setUser({
        auth: 'false',
        proRights: {},
      })
      analytics.setScreen('')

      analytics.setGlobalParams({
        userId: undefined,
        userType: undefined,
        date: new Date().toISOString(),
      })

      channels.forEach(channel => {
        channel.setParams({})
      })
    }

    const handleRouteChange = () => {
      if (!analytics) {
        return
      }

      analytics.setScreen(window.location.pathname)
    }

    window.addEventListener('popstate', handleRouteChange)

    return () => {
      window.removeEventListener('popstate', handleRouteChange)
    }
  }, [authData?.authenticated, authData?.user?.id, authData?.user?.type])

  return {
    analytics: analytics || null,
    channels: {
      request: requestChannel,
      share: shareChannel,
      song: songChannel,
    },
  }
}
